/**
 * djb2-xor accumulator, identical to the prototype's stateHash() folding step:
 * h = (imul(h, 33) ^ (n | 0)) >>> 0, seeded with 5381. Keyframe hashes in
 * replays are computed with this; changing it desyncs every recorded run.
 */
export class Djb2 {
  private h = 5381;

  /** Fold a number in. Matches the prototype: (n | 0) truncates toward zero mod 2^32. */
  add(n: number): void {
    this.h = (Math.imul(this.h, 33) ^ (n | 0)) >>> 0;
  }

  addString(s: string): void {
    for (let i = 0; i < s.length; i++) this.add(s.charCodeAt(i));
  }

  get value(): number {
    return this.h;
  }
}
